import SectionHead from "./SectionHead";

export default function Steps({ steps }) {
  return (
    <section className="py-20" style={{ background: "#f8f8fb" }}>
      <div className="max-w-7xl mx-auto px-6">
        <SectionHead eyebrow={steps.eyebrow} title={steps.title} />
        <div className="grid grid-cols-1 gap-5 md:grid-cols-3">
          {steps.items.map((s, i) => (
            <div key={i} className="dc-card p-7 overflow-hidden" style={{ position: "relative" }}>
              <div className="absolute top-3 right-4 font-extrabold text-violet-50 select-none"
                style={{ fontSize: 64, lineHeight: 1, letterSpacing: -3 }}>
                {s.n}
              </div>
              <div className="w-9 h-9 rounded-xl bg-violet-600 flex items-center justify-center font-extrabold text-white text-sm mb-4">
                {i + 1}
              </div>
              <div className="font-bold text-gray-900 mb-2">{s.title}</div>
              <div className="text-gray-500 text-sm leading-relaxed">{s.desc}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}